import React from 'react';

const GridBackground = () => {
    return (
        <div className="fixed inset-0 pointer-events-none">
            {/* Base black background */}
            <div className="absolute inset-0 bg-black" />

            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-purple-900/5 via-black to-black" />

            {/* Purple radial gradient */}
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(147,51,234,0.05),transparent_70%)]" />

            {/* Grid pattern with purple lines */}
            <div className="absolute inset-0"
                style={{
                    backgroundImage: `
                        linear-gradient(to right, rgba(147,51,234,0.05) 1px, transparent 1px),
                        linear-gradient(to bottom, rgba(147,51,234,0.05) 1px, transparent 1px)
                    `,
                    backgroundSize: '64px 64px'
                }}
            />

            {/* Finer grid pattern */}
            <div className="absolute inset-0"
                style={{
                    backgroundImage: `
                        linear-gradient(to right, rgba(147,51,234,0.025) 1px, transparent 1px),
                        linear-gradient(to bottom, rgba(147,51,234,0.025) 1px, transparent 1px)
                    `,
                    backgroundSize: '16px 16px'
                }}
            />

            {/* Glowing orbs with pure purple */}
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/10 rounded-full filter blur-3xl animate-pulse" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-600/5 rounded-full filter blur-3xl animate-pulse"
                style={{ animationDelay: '1s' }}
            />

            {/* Additional subtle accent points */}
            <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-purple-500/10 rounded-full filter blur-xl animate-pulse"
                style={{ animationDelay: '2s' }}
            />
        </div>
    );
};

export default GridBackground;